import React from "react";
import styled from "styled-components";

interface Props {
    style?: React.CSSProperties;
}

const TableCell: React.FC<Props> = ({ style, children }) => {
    return (
        <StyledTableCell style={style}>
            <span>{children}</span>
        </StyledTableCell>
    );
};

const StyledTableCell = styled.td`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 100%;

    color: #929cb9;

    font-weight: ${(props) => props.theme.fontWeight.normal};
    font-size: 0.9rem;
    overflow: auto;

    user-select: none;

    white-space: nowrap;

    border-right: solid 0.5px ${(props) => props.theme.colors.neutral[100]};
    &:last-child {
        border-right: none;
    }
`;

export default TableCell;
